<template>
  <hic-dialog v-loading="meta.loading" :close-on-click-modal="false" :visible="visible" append-to-body :title="title" @open="open" @close="cancel" width="50rem">
    <el-form ref="info" v-if="value" :rules="rules" :model="value" @save.native.prevent label-width="7rem">
      <el-form-item label="名称：" prop="name">
        <el-input clearable type="text" placeholder="请输入名称" maxlength="50" show-word-limit v-model="value.name" size="small" v-hic-focus />
      </el-form-item>
      <el-row type="flex">
        <el-form-item label="应用领域：" prop="scope">
          <hic-dict-selector dict-type="MrScope" is-enum v-model="value.scope" auto />
        </el-form-item>
        <el-form-item label="分类目录：" prop="category">
          <hic-dict-selector dict-type="MrCategory" v-model="value.category" auto />
        </el-form-item>
        <el-form-item label="排序：" prop="seqNo">
          <el-input clearable type="number" placeholder="请输入数字" class="edit-input" v-model="value.seqNo" size="small" />
        </el-form-item>
      </el-row>
      <el-row type="flex">
        <el-form-item label="应用范围：" prop="mrRange">
          <el-radio-group v-model="value.mrRange" :disabled="!!value.isMr">
            <el-radio :label="item.text" v-for="(item, index) in this.dictEnum.MrRange" :key="index">{{ item.text }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="性别限制：" prop="gender">
          <el-radio-group v-model="value.gender">
            <el-radio v-for="item in dictEnum.MrGender" :key="item.id" :label="item.name">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-form-item label="关键字：" prop="keyword">
        <el-input clearable type="text" maxlength="50" show-word-limit placeholder="请输入关键字，多个关键字用“、”隔开" v-model="value.keyword" size="small" />
      </el-form-item>
      <el-form-item label="内容：" prop="content">
        <el-input axlength="500" show-word-limit clearable :rows="6" type="textarea" placeholder="请输入内容" v-model="value.content" size="small" />
      </el-form-item>

      <el-form-item label="备注：" prop="memo">
        <el-input maxlength="200" show-word-limit clearable :rows="2" type="textarea" placeholder="请输入备注" v-model="value.memo" size="small" />
      </el-form-item>
    </el-form>
    <el-row slot="footer">
      <el-button @click.native="cancel" type="info">关 闭</el-button>
      <el-button :loading="meta.loading" @click="save" type="primary">保 存</el-button>
    </el-row>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    components: {},
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        type: "",
        condition: {},
        rules: {
          sortId: [{ required: false, message: "请选择知识库类别", trigger: "change" }],
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          keyword: [
            {
              required: true,
              message: "请输入关键字，多个关键字用“、”隔开",
              trigger: "blur",
            },
          ],
          mrScope: [{ required: true, message: "请选领域", trigger: "change" }],
          category: [{ required: true, message: "请选分类目录", trigger: "change" }],
          content: [{ required: true, message: "请输内容", trigger: "blur" }],
          mrRange: [{ required: true, message: "请选择范围", trigger: "change" }],
          gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum", "user"]),
      MrScopeVal() {
        return this.dictEnum.MrScope.map((item, index) => {
          return {
            code: item.text,
            text: item.text,
          };
        });
      },
      MrElement() {
        return this.dict.MrElement.map((item, index) => {
          return {
            code: item.id,
            text: item.text + "-" + item.type,
          };
        });
      },
      title() {
        if (!this.value?.id) {
          return "辅助录入新建";
        }
        return "辅助录入编辑";
      },
    },
    methods: {
      open() {
        this.$nextTick(() => {
          if (this.$refs.info) this.$refs.info.clearValidate();
        });
      },
      cancel() {
        this.$emit("update:visible", false);
      },
      save() {
        this.$refs.info.validate((valid) => {
          this.$api.Help.save(this.value)
            .then((res) => {
              this.$message.success("保存成功！");
              this.$emit("saved");
              this.$emit("update:visible", false);
            })
            .catch((err) => {
              this.$message.error(err);
            });
        });
      },
    },
  };
</script>
